<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";
import {menuItems_0} from "../../../components/menu.js"
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Editar Usuário",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      userPctsData: null,

      showFormUserEmpresa: false,
      userEmpresasData: {},
      userEmpresaData: {},
      submittedUserEmpresa: false,
      dtListPesqEmpresa: null,

      showFormUserMenu: false,
      userMenusData: {},
      userMenuData: {},
      submittedUserMenu: false,
      menuOptions: [],
      selectedMenus: [],
      flatMenuMap: {},


      userTokensData: {},
      userTokenData: {},

      inputTypeClientSecret: 'password',
      inputTypeSenha: 'password',
      selected: null,
      showFormToken: false,
      listahubs: [
        { value: null, hubItem: 'Selecionar um HUB' },
        { value: 'blingv2', hubItem: 'Bling API V2' },
        { value: 'anymarket', hubItem: 'Anymarket' }
      ],
      formToken: {
        hub: null,
        login: '',
        senha: '',
        token: '',
        clientId: '',
        clientSecret: '',
        accessToken: '',
        refreshToken: ''
      },

      totalFaturado: 0,
      totalComissao: 0,
      periodo: null,
      pedidosData: null,
      errosValid: null,
      contClickAvanc: 0,
      usuarioData: {
        id: 0,
        tipo: 'repres',
        status: true,
        estado: "",
        cidade: "",
      },
      cidades: [],
      cacheCidades: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,
      submittedToken: false,

      title: "Editar Usuário",
      items: [
        {
          text: "Usuários",
          href: "/usuarios/list",
        },
        {
          text: "Editar Usuário",
          active: true,
        },
      ],
      token_api: null,
      emojiToken: "😎",
      actualTokenEmoji: 1,
      typeInput: "password",
      showApitoken: false
    };
  },
  validations: {
    usuarioData: {
      name: {
        required: helpers.withMessage("Campo nome obrigatório, favor preencher.", required),
      },
      email: {
        required: helpers.withMessage("Campo email obrigatório, favor preencher.", required),
      },
      tipo: {
        required: helpers.withMessage("Campo tipo obrigatório, favor preencher.", required),
      },
      cnpj: {
        required: helpers.withMessage("Campo CNPJ obrigatório, favor preencher.", required),
      },
      cidade: {
        required: helpers.withMessage("Campo cidade obrigatório, favor preencher.", required),
      },
      estado: {
        required: helpers.withMessage("Campo estado obrigatório, favor preencher.", required),
      },
      codrepres: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
      password: {
        required: helpers.withMessage("Campo senha obrigatório, favor preencher.", required),
      },
    }
  },
  methods: {

    async carregarCidades() {
      // console.log("chamando api")
      const uf = this.usuarioData.estado;
      if (this.cacheCidades[uf]) {
        this.cidades = this.cacheCidades[uf];
        return;
      }

      const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
      const data = await response.json();
      this.cidades = data;
      this.cacheCidades[uf] = data;
    },

    mostrarApiToken(){
      console.log("mostrarApiToken")

        this.emojiToken = "👀"
        this.typeInput = "text"
        this.showApitoken = this.showApitoken ? false : true
    },

    mudaremoji(isHovering){
      console.log("mudaremoji")
      if(isHovering){
        this.emojiToken = "👀"
        this.typeInput = "text"
      }else{
        this.emojiToken = "😎"
        this.typeInput = "password"
      }

      if(this.showApitoken === true){
        this.emojiToken = "👀"
        this.typeInput = "text"
      }
    },

    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqEmpresa = res.data
        })
      }
    },


    delAllUserMenu(){
      console.log('delAllUserMenu')
      
      if (!this.userMenusData || this.userMenusData.length === 0) {
        Swal.fire({
           icon: 'info',
           title: 'Lista vazia',
           text: 'Não há permissões para excluir.',
        });
        return;
      }

      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Excluir TODAS as permissões?",
        text: "Esta operação excluirá todas as permissões de menu listadas. É irreversível!",
        confirmButtonText: "Sim, excluir tudo",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#f46a6a"
      }).then(async (result) => {
        if (result.value) {
          Swal.fire({
            title: 'Aguarde',
            text: 'Estamos processando a exclusão das permissões...',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading()
            }
          });

          api.delete(`${getBaseUrl()}api/usumenu`, {
              params: {
                'user_id': this.idData
              }
          }).then(() => {
              Swal.fire({
              position: "center",
              icon: "success",
              title: "Todas as permissões foram excluídas com sucesso!!",
              showConfirmButton: false,
              timer: 1500
              })
              this.carregarDados();
          }).catch(error => {
              console.error(error);
              Swal.fire({
              position: "center",
              icon: "error",
              title: "Houve um problema ao excluir as permissões!",
              showConfirmButton: false,
              timer: 1500
              })
          });
        }
      })
    },

    delUserMenu(permissaoId){
      console.log('delUserMenu')

      console.log('deletar: ' + permissaoId)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/usumenu`, {
            params: {
              'user_id': this.idData,
              'permissao_id': permissaoId
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Permissão excluída com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    delUserEmpresa(idData){
      console.log('delUserempresa')

      console.log('deletar: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/usuempresa`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })


        }
      })


    },


    async confUserMenu(){
      console.log('confUserMenu')
      this.submittedUserMenu = true
      
      if (this.selectedMenus.length > 0) {
        this.showFormUserMenu = false

        Swal.fire({
             title: 'Aguarde',
             text: 'Estamos processando as configurações das permissões...',
             allowOutsideClick: false,
             didOpen: () => {
               Swal.showLoading()
             }
        });

        let userMenuList = this.selectedMenus.map(menuId => {
           return {
              user_id: this.idData,
              menu_id: menuId,
              chave: this.flatMenuMap[menuId] || ''
           }
        })

        try {
           await api.post(`${getBaseUrl()}api/usumenu`, {
              userMenuData: userMenuList
           })
           
           Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
           })
           this.selectedMenus = []
           this.carregarDados()
           
        } catch (error) {
           console.error("Erro ao salvar menus", error)
           Swal.fire({
            icon: "error",
            title: "Erro ao salvar",
            text: "Ocorreu um erro ao salvar algumas permissões."
           })
        }
      }
    },

    confUserEmpresa(){
      console.log('confUserEmpresa')
      this.submittedUserEmpresa = true
      this.userEmpresaData.user_id = this.idData
      if (this.userEmpresaData.empresa_id) {
        this.showFormUserEmpresa = false
        api.post(`${getBaseUrl()}api/usuempresa`, {
          userEmpresaData: this.userEmpresaData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },


    adicPermissao(){
      console.log('adicPermissao')
      this.activeTab = 1
      this.userMenuData = {}
      this.selectedMenus = []
      this.submittedUserMenu = false
      this.showFormUserMenu = true
    },


    adicPermissaoEmpresa(){
      console.log('adicPermissaoEmpresa')
      this.activeTab = 1
      this.userEmpresaData = {}
      this.submittedUserEmpresa = false
      this.showFormUserEmpresa = true
    },


    editarToken(data){
      this.userTokenData = data
      this.showFormToken = true

    },

    confToken() {
      console.log('confToken')
      this.userTokenData.user_id = this.idData

      if (this.userTokenData.hub && this.userTokenData.validade) {
        this.submittedToken = false

        api.post(`${getBaseUrl()}api/usutoken`, {
          usertokenData: this.userTokenData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormToken = false

          // this.usuarioData = res.data[0]
          // this.updating = false
          //
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

          // this.$router.push('/usuarios/list')
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })
      }





    },



    mudouPeriodo(){
      console.log('mudouPeriodo')

      this.carregarDados()

    },


    carregarDados(){
      this.updating = true
      console.log(`idData: ${this.idData}`)
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/usuario`, {
          params: { iddata: this.idData, periodo: this.periodo }
        }).then((res) => {
          console.log('then axios user')
          console.log(res.data)
          // console.log('menuItens_0')
          // console.log(menuItems_0)
          
          const existingUserMenus = res.data[3] || []
          const existingIds = new Set(existingUserMenus.map(m => m.menu_id))
          
          let groups = []
          let currentTitleGroup = null
          let flatMap = {}
          
          const processItem = (item) => {
             if (item.id) {
                flatMap[item.id] = item.label
             }
          }

          menuItems_0.forEach((menuItem) => {
            processItem(menuItem)
            
            if (menuItem.isTitle) {
               let newGroup = {
                  label: this.$t(menuItem.label),
                  options: []
               }
               groups.push(newGroup)
               currentTitleGroup = newGroup
            } else if (menuItem.subItems && menuItem.subItems.length > 0) {
               let subOpts = menuItem.subItems
                   .filter(sub => !existingIds.has(sub.id))
                   .map(sub => {
                      processItem(sub)
                      return { value: sub.id, label: this.$t(sub.label) }
                   })
               
               if (subOpts.length > 0) {
                   groups.push({
                      label: this.$t(menuItem.label),
                      options: subOpts
                   })
               }
            } else {
               if (!existingIds.has(menuItem.id)) {
                   let opt = { value: menuItem.id, label: this.$t(menuItem.label) }
                   if (currentTitleGroup) {
                      currentTitleGroup.options.push(opt)
                   } else {
                      if (groups.length === 0) {
                          groups.push({ label: 'Geral', options: [] })
                      }
                      groups[groups.length - 1].options.push(opt)
                   }
               }
            }
          })
          
          this.menuOptions = groups.filter(g => g.options.length > 0)
          this.flatMenuMap = flatMap
          //console.log('menuOptions')
          //console.log(flatMenuMap)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`)
          }else{
            this.usuarioData = res.data[0]
            
            let userLogado = JSON.parse(localStorage.getItem('user'))
            //console.log(`userLogado: ${JSON.stringify(userLogado)}`)
            this.token_api = userLogado.token
            
            this.pedidosData = res.data[1]
            this.userTokensData = res.data[2]
            this.userMenusData = res.data[3]
            this.userEmpresasData = res.data[4]
            this.userPctsData = res.data[5]
            // console.log('menuItems_0')
            // console.log(menuItems_0)
            // this.userMenusData.forEach((value) => {
            // //
            //     console.log(value.id)
            //     this.menuItens.forEach((valsub) => {
            //         if (valsub.id === value.id) {
            //           console.log(valsub)
            //           value['descricao'] = valsub.value
            //         }
            //     })
            // })
            let totalFat = 0
            let totalComiss = 0
            if (this.pedidosData) {
              this.pedidosData.forEach((value) => {
                totalFat = totalFat + value.valorliq
                totalComiss = totalComiss + parseFloat(value.valorcomissao)
              })
              this.totalFaturado = totalFat
              this.totalComissao = totalComiss
            }
            this.idData = this.usuarioData.id
            this.title = `Editar Usuário (${this.usuarioData.id}) ${this.usuarioData.name}`
            this.updating = false
          }
        })
      }else{
        this.title = `Criando Novo Usuário`
        this.updating = false
      }
    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      this.v$.$touch()
      console.log('avancarSeg')

      let validPass = false
      const contSpecial = /[`!@#$%^&*()_+\-=\\|,.<>?~]/.test(this.usuarioData.password)
      const contLetters = /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/.test(this.usuarioData.password)
      const contNumbers = /[0-9]/.test(this.usuarioData.password)

      if (this.usuarioData.password && this.usuarioData.password.length >= 8 && contSpecial && contLetters && contNumbers){
        validPass = true
      }


      if (this.idData === 0 && !validPass){
        Swal.fire({
          text: "Favor preencher o campo senha com o mínimo de 8 caracteres, contento letras e números",
          icon: "warning",
          position: "top-end",
          showConfirmButton: false,
          timer: 2500
        })
      }else{
        if (this.usuarioData.password && !validPass){
          Swal.fire({
            text: "Favor preencher o campo senha com o mínimo de 8 caracteres, contento letras e números",
            icon: "warning",
            position: "top-end",
            showConfirmButton: false,
            timer: 2500
          })
        }else{
          this.updating = true
          this.errosValid = []
          api.post(`${getBaseUrl()}api/usuario`, {
            usuarioData: this.usuarioData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.usuarioData = res.data[0]
            this.updating = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.$router.push('/usuarios/list')
          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof  erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
            this.activeTab = 0
          })
        }
      }
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },


  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }

    let dataAtu = new Date()
    const anoAtu = dataAtu.getFullYear()
    const mesAtu = ("0" + (dataAtu.getMonth() + 1)).slice(-2)
    // console.log(dataAtu.getFullYear())
    // console.log(dataAtu.getMonth())
    // console.log(mesAtu)
    // console.log(anoAtu)
    this.periodo = anoAtu + '-' + mesAtu

    this.carregarDados()


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit"  >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="adicPermissao">-->
<!--                <i class="bx bx-plus font-size-16 align-middle me-2"></i>-->
<!--                Nova Permissão Menu-->
<!--              </b-button>-->

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento"  >-->
              <!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
              <!--                Cancelar Orçamento-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-warning" class="mx-2" @click="novoAnexo" :disabled="clienteData.id === 0">-->
              <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
              <!--                Novo Anexo-->
              <!--              </b-button>-->

            </div>
          </div>
        </div>
      </div>

      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Informações Principais</h4>
<!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <form class="needs-validation" @submit.prevent="formSubmit">
                  <div class="row">

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="inputName">Nome</label>
                        <input
                            id="inputName"
                            v-model="usuarioData.name"
                            type="text"
                            class="form-control"
                            placeholder="Nome"
                            :class="{'is-invalid': submitted && v$.usuarioData.name.$error,}"/>
                        <div v-if="submitted && v$.usuarioData.name.$error"
                             class="invalid-feedback">
                          <span v-if="v$.usuarioData.name.required.$message">{{ v$.usuarioData.name.required.$message }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="inputEmail">Email</label>
                      <div class="position-relative">

                        <!--    max length igual a 100 pois é o tamanho do campo nas tabelas   -->
                        <input
                            id="inputEmail"
                            type="text"
                            :maxlength="100"
                            v-model="usuarioData.email"
                            class="form-control"
                            placeholder="E-mail"
                            :class="{'is-invalid': submitted && v$.usuarioData.email.$error,}"/>
                        <div v-if="submitted && v$.usuarioData.email.$error" class="invalid-feedback">
                          <span v-if="v$.usuarioData.email.required.$message">{{ v$.usuarioData.email.required.$message }}</span>
                        </div>
                        <div class="chat-input-links" v-if="usuarioData.email">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a
                                  href="javascript: void(0);"
                                  v-b-tooltip.hover
                                  placement="top"
                                  title="Enviar e-mail">
                                <i class="mdi mdi-email-send-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">
                        <label for="tipo">Perfil</label>
                        <select
                            id="tipo"
                            v-model="usuarioData.tipo"
                            class="form-control"
                            :class="{'is-invalid': submitted && v$.usuarioData.tipo.$error,}">
                          <option value="admin">Administrador</option>
                          <option value="cotacao">Cotação</option>
                          <option value="coletor">Coletor</option>
                          <option value="gerent">Gerente</option>
                          <option value="logist">Logística</option>
                          <option value="repres">Representante</option>
                          <option value="superv">Supervisor</option>
                          <option value="tms_free">TMS Free</option>
                          <option value="tms_plus">TMS Plus</option>
                          <option value="tms_enterprise">TMS Enterprise</option>
                          <option value="tms_pro">TMS Pro</option>

                        </select>
                        <div v-if="submitted && v$.usuarioData.tipo.$error" class="invalid-feedback">
                          <span v-if="v$.usuarioData.tipo.required.$message">{{ v$.usuarioData.tipo.required.$message }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="CPF">CPF</label>
                      <div class="position-relative">
                        <input
                            id="cpf"
                            type="tel"
                            v-model="usuarioData.cnpj"
                            class="form-control"
                            placeholder="CPF"/>

                            <!-- Trecho comentado pois botão não leva a nenhuma ação-->
<!--                        <div class="chat-input-links" v-if="usuarioData.cnpj">-->
<!--                          <ul class="list-inline mb-0">-->
<!--                            <li class="list-inline-item">-->
<!--                              <a-->
<!--                                  href="javascript: void(0);"-->
<!--                                  v-b-tooltip.hover-->
<!--                                  placement="top"-->
<!--                                  title="Consultar CNPJ">-->
<!--                                <i class="mdi mdi-cloud-search-outline"></i>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </div>-->
                      </div>
                    </div>

                    <hr class="mt-5"/>

                  </div>


                  <div class="row mt-3">

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="estado">Estado</label>
                        <select
                            id="estado"
                            v-model="usuarioData.estado"
                            class="form-control"
                            @change="carregarCidades"
                        >
                          <option value="" hidden>Selecionar Estado...</option>
                          <option value="AC">AC</option>
                          <option value="AL">AL</option>
                          <option value="AP">AP</option>
                          <option value="AM">AM</option>
                          <option value="BA">BA</option>
                          <option value="CE">CE</option>
                          <option value="DF">DF</option>
                          <option value="ES">ES</option>
                          <option value="GO">GO</option>
                          <option value="MA">MA</option>
                          <option value="MT">MT</option>
                          <option value="MS">MS</option>
                          <option value="MG">MG</option>
                          <option value="PA">PA</option>
                          <option value="PB">PB</option>
                          <option value="PR">PR</option>
                          <option value="PE">PE</option>
                          <option value="PI">PI</option>
                          <option value="RJ">RJ</option>
                          <option value="RN">RN</option>
                          <option value="RS">RS</option>
                          <option value="RO">RO</option>
                          <option value="RR">RR</option>
                          <option value="SC">SC</option>
                          <option value="SP">SP</option>
                          <option value="SE">SE</option>
                          <option value="TO">TO</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="cidade">Cidade</label>
                        <select
                            id="cidade"
                            v-model="usuarioData.cidade"
                            class="form-control"
                            :disabled="!usuarioData.estado || cidades.length === 0"
                        >
                          <option value="" hidden>Selecionar Cidade...</option>
                          <option v-for="cidade in cidades" :key="cidade.id" :value="cidade.nome">
                            {{ cidade.nome }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="codrepres">Código</label>
                        <input
                            id="codrepres"
                            v-model="usuarioData.codrepres"
                            type="text"
                            class="form-control"
                            placeholder="Código de carteira"
                            :class="{'is-invalid': submitted && v$.usuarioData.codrepres.$error,}"/>
                        <div v-if="submitted && v$.usuarioData.codrepres.$error" class="invalid-feedback">
                          <span v-if="v$.usuarioData.codrepres.required.$message">{{ v$.usuarioData.codrepres.required.$message }}</span>
                        </div>
                      </div>
                    </div>

<!--                    <div class="col-md-3">-->
<!--                      <div class="mb-3">-->
<!--                        <label for="comissao">Comissão</label>-->
<!--                        <input-->
<!--                            id="comissao"-->
<!--                            v-model="usuarioData.comissao"-->
<!--                            type="number"-->
<!--                            class="form-control"-->
<!--                            placeholder="Comissão"/>-->

<!--                      </div>-->
<!--                    </div>-->

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="password">Senha</label>
                        <input
                            id="password"
                            v-model="usuarioData.password"
                            type="password"
                            class="form-control"
                            :placeholder="idData === 0 ? 'Senha' : 'Senha, deixar em branco caso não queira alterar'"
                            :class="{'is-invalid': submitted && usuarioData.id === 0 && v$.usuarioData.password.$error,}"/>
                        <div v-if="submitted && usuarioData.id === 0 && v$.usuarioData.password.$error" class="invalid-feedback">
                          <span v-if="v$.usuarioData.password.required.$message">{{ v$.usuarioData.password.required.$message }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="tel1">Telefone</label>
                      <div class="position-relative">
                        <input
                            id="tel1"
                            type="tel"
                            v-model="usuarioData.tel1"
                            class="form-control"
                            placeholder="Telefone"/>

                        <div class="chat-input-links" v-if="usuarioData.tel1">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a
                                  href="javascript: void(0);"
                                  v-b-tooltip.hover
                                  placement="top"
                                  title="Abrir Whatsapp">
                                <i class="mdi mdi-phone"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <div class="mb-3 align-items-end align-content-end float-end">
                        <label for="tel1">Status</label>
                        <div class="position-relative">
                          <b-form-checkbox switch size="lg" v-model="usuarioData.status" >
                            {{ usuarioData.status ? 'Ativo' : 'Inativo' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>


<!--                    <div class="col-md-3">-->
<!--                      <div class="mb-3 align-items-end align-content-end float-end">-->
<!--                        <label for="stsrestlog">Restrição Logística</label>-->
<!--                        <div class="position-relative">-->
<!--                          <b-form-checkbox switch size="lg" v-model="usuarioData.stsrestlog" >-->
<!--                            {{ usuarioData.stsrestlog ? 'Ativo' : 'Inativo' }}-->
<!--                          </b-form-checkbox>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->


                  </div>

                </form>

              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <router-link
                    to="/usuarios/list"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Usuários
                </router-link>
              </div>

              <div class="col-sm-6">
                <div class="text-end">
                  <button class="btn btn-success" @click="activeTab = 1">
                    Avançar para Permissões
                    <i class="mdi mdi-arrow-right me-1"></i>
                  </button>
                </div>
              </div>

            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-layer d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Permissões</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Permissões para Menu</h4>
                    <!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-12">
                      <div class="mb-3 d-flex">

                        <b-button variant="outline-success" class="mx-2" @click="adicPermissao"  >
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova Permissão
                        </b-button>

                        <b-button variant="outline-danger" class="mx-2" @click="delAllUserMenu" :disabled="!userMenusData || userMenusData.length === 0">
                          <i class="bx bx-trash font-size-16 align-middle me-2"></i>
                          Excluir Todas
                        </b-button>


                        <!--                        <input-->
                        <!--                            id="periodo"-->
                        <!--                            v-model="periodo"-->
                        <!--                            type="month"-->
                        <!--                            @change="mudouPeriodo"-->
                        <!--                            class="form-control text-end"-->
                        <!--                            style="max-width: 200px;"-->
                        <!--                            placeholder="Período"/>  -->
                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Menu ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col" class="text-end">Usuário</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of userMenusData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" class="text-body fw-bold">
                              {{ data.id }}
                            </a>

                          </td>
                          <td> {{ data.menu_id }} </td>
                          <td> {{ $t(data.chave) }} </td>
                          <td class="text-end"> {{ data.created_by }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>

                          <td class="text-end">
                            <div class="button-items">

                              <b-button variant="outline-danger" @click="delUserMenu(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>

                            </div>
                          </td>
                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>


                  <div class="card-body">
                    <h4 class="card-title mb-4">Permissões para Empresa</h4>

                    <div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="adicPermissaoEmpresa"  >
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Nova Permissão
                        </b-button>

                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Empresa ID</th>
                          <th scope="col" class="text-end">Usuário</th>
                          <th scope="col" class="text-end">Data</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of userEmpresasData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" class="text-body fw-bold">
                              {{ data.id }}
                            </a>

                          </td>
                          <td> {{ data.empresa_id }} </td>
                          <td class="text-end"> {{ data.created_by }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>

                          <td class="text-end">
                            <div class="button-items">

                              <b-button variant="outline-danger" @click="delUserEmpresa(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>

                            </div>
                          </td>
                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>



                  <div class="card-body">
                    <h4 class="card-title mb-4">Pacotes</h4>

                    <div class="col-2">
                      <div class="mb-3">

<!--                        <b-button variant="outline-success" class="mx-2" @click="adicPermissaoEmpresa"  >-->
<!--                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
<!--                          Nova Permissão-->
<!--                        </b-button>-->

                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Tabela</th>
                          <th scope="col" class="text-end">Limite</th>
                          <th scope="col" class="text-end">Consumo</th>
                          <th scope="col" class="text-end">Data</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data of userPctsData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>
                          <td> {{ data.descricao }} </td>
                          <td> {{ data.tabela }} </td>
                          <td class="text-end"> {{ data.limite }} </td>
                          <td class="text-end"> {{ data.consumo }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
<!--                          <td class="text-end">-->
<!--                            <div class="button-items">-->

<!--                              <b-button variant="outline-danger" @click="delUserEmpresa(data.id)">-->
<!--                                <i class="mdi mdi-trash-can d-block font-size-16"></i>-->
<!--                              </b-button>-->

<!--                            </div>-->
<!--                          </td>-->
                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>




                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Permissões
                </button>
              </div>



            </div>
          </b-card-text>
        </b-tab>


        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-key d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Tokens</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Token</h4>
<!--                    <p class="card-title-desc">Selecione os usuários que são supervisionados por este usuário</p>-->

                    <div class="col-12">
                      <div class="mb-3">
                        <label for="token_api">Meu Token API:</label>
                          <div class="d-flex">
                            <input
                                id="token_api"
                                :type=typeInput
                                v-model="token_api"
                                readonly
                                style="min-width: 50%;"
                              >
                              <span style="font-size: 24px; cursor: pointer;" title="Revelar Token" @mouseenter="mudaremoji(true)" @mouseleave="mudaremoji(false)" @click="mostrarApiToken">
                              {{ emojiToken }}
                            </span>
                          </div>
                      </div>
                    </div>

                    <!--<div class="col-2">
                      <div class="mb-3">

                        <b-button variant="outline-success" class="mx-2" @click="showFormToken = true"  >
                          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                          Novo Token
                        </b-button>
                      </div>
                    </div>


                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">HUB</th>
                          <th scope="col">Validade</th>
                          <th scope="col">Data</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data of userTokensData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" @click="editarToken(data)" class="text-body fw-bold">
                              {{ data.id }}
                            </a>

                          </td>
                          <td> {{ data.hub }} </td>
                          <td> {{ data.validade }} </td>
                          <td class="text-end"> {{ formatDateTime(data.created_at) }} </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar para Permissões
                </button>
              </div>



            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>

    <!-- Início Modal implementado para cadastro | edição de tokens -> Pablo -->
    <b-modal  size="lg"
              title="Criar novo registro de token" v-model="showFormToken" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">
              <div class="row">


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="hub">Hub</label>
                    <select
                        id="hub"
                        v-model="userTokenData.hub"
                        class="form-control"
                        :class="{'is-invalid': submittedToken && !userTokenData.hub}">
                      <option value="AMAZON">Amazon</option>
                      <option value="ANYMARKET">Any Market</option>
                      <option value="B2WNOVA">B2W Nova Api</option>
                      <option value="BLING">Bling</option>
                      <option value="LEROYMER">Leroy Merlin</option>
                      <option value="LOJAMEC">Loja do Mecânico</option>
                      <option value="MAGALU">Magazine Luiza</option>
                      <option value="SKYHUB">SkyHub</option>
                      <option value="TRAYCORP">TrayCorp</option>
                      <option value="VTEX">Vtex</option>

                    </select>
                    <div v-if="submittedToken && !userTokenData.hub" class="invalid-feedback">
                      <span>Campo hub obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="validade">Validade</label>
                    <input
                        id="validade"
                        v-model="userTokenData.validade"
                        type="number"
                        class="form-control"
                        placeholder="Validade"
                        :class="{'is-invalid': submittedToken && !userTokenData.validade}"/>
                    <div v-if="submittedToken && !userTokenData.validade" class="invalid-feedback">
                      <span>Campo validade obrigatório, favor preencher.</span>
                    </div>

                  </div>
                </div>


                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="login">Login</label>
                    <input
                        id="login"
                        v-model="userTokenData.login"
                        type="text"
                        class="form-control"
                        placeholder="Login"/>

                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="senha">Senha</label>
                    <input
                        id="senha"
                        v-model="userTokenData.senha"
                        type="text"
                        class="form-control"
                        placeholder="Senha"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="token">Token</label>
                    <input
                        id="token"
                        v-model="userTokenData.token"
                        type="text"
                        class="form-control"
                        placeholder="Token"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="cliid">Client ID</label>
                    <input
                        id="cliid"
                        v-model="userTokenData.cliid"
                        type="text"
                        class="form-control"
                        placeholder="Client ID"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="clisecret">Client Secret</label>
                    <input
                        id="clisecret"
                        v-model="userTokenData.clisecret"
                        type="text"
                        class="form-control"
                        placeholder="Client Secret"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="actoken">Access Token</label>
                    <textarea
                        id="actoken"
                        v-model="userTokenData.actoken"
                        type="text"
                        rows="2"
                        :disabled="true"
                        class="form-control"
                        placeholder="Access Token"/>

                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="rftoken">Refresh Token</label>
                    <textarea
                        id="rftoken"
                        v-model="userTokenData.rftoken"
                        type="text"
                        rows="2"
                        :disabled="true"
                        class="form-control"
                        placeholder="Refresh Token"/>

                  </div>
                </div>


              </div>

              <div class="row">


                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormToken = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confToken">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>

              </div>




            </form>


          </div>
        </div>
      </div>
    </b-modal>
    <!-- Fim Modal implementado para cadastro | edição de tokens -> Pablo -->



    <b-modal  size="lg"
              title="Criar nova permissão para menu" v-model="showFormUserMenu" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">
            <form class="needs-validation">
              <div class="row">
                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="hubmenu">Menu</label>
                    <multiselect
                        id="hubmenu"
                        v-model="selectedMenus"
                        :options="menuOptions"
                        :groups="true"
                        :group-select="true"
                        mode="tags"
                        value-prop="value"
                        label="label"
                        track-by="value"
                        :searchable="true"
                        placeholder="Pesquisar menus"
                        class="form-control"
                        :class="{'is-invalid': submittedUserMenu && selectedMenus.length === 0}">
                       <template #noResult>
                          Oops! Nenhum elemento encontrado.
                       </template>
                    </multiselect>
                    <div v-if="submittedUserMenu && selectedMenus.length === 0" class="invalid-feedback" style="display:block;">
                      <span>Campo menu obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormUserMenu = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confUserMenu">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>




    <b-modal  size="lg"
              title="Criar nova permissão para empresa" v-model="showFormUserEmpresa" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">
            <form class="needs-validation">
              <div class="row">

                <div class="col-md-12">
                  <div class="mb-3">
                    <span>empresa</span>
                    <multiselect id="userempresaid"
                                 class="mt-2"
                                 @search-change="pesqEmpresa"
                                 v-model="userEmpresaData.empresa_id"
                                 placeholder="Pesquisar serviços"
                                 :options="dtListPesqEmpresa"
                                 :searchable="true"
                                 label="nome"
                                 track-by="nome"
                                 :style="submittedUserEmpresa && !userEmpresaData.empresa_id ? 'border: 1px solid #f86c6b !important;' : ''"
                                 value-prop="id">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                          <span class="text-info">
                            {{ slotProps.option.id }}
                          </span>
                            <span class="mx-4" >
                          </span>
                          </div>
                          <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                          <span class="mx-4">{{ slotProps.option.cnpj }}</span>
                          <span class="mx-4"></span>
                          <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submittedUserEmpresa && !userEmpresaData.empresa_id">
                      <span class="text-danger font-size-11">Campo Empresa obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>



              </div>
              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormUserEmpresa = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confUserEmpresa">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

  </Layout>
</template>
